// import React from "react";
// import Slider from "react-slick";
// import { Box, Typography, useTheme } from "@mui/material";
// import { keyframes } from "@emotion/react";

// const moveWave = keyframes`
//   0% {
//     transform: translateX(0);
//   }
//   100% {
//     transform: translateX(-100%);
//   }
// `;

// const SliderComponent = () => {
//   const theme = useTheme();
  
//   const images = [
//     require("../images/image1.jpg"),
//     require("../images/image2.jpg"),
//     require("../images/image3.jpg"),
//   ];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 700,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//     fade: true,
//   };

//   return (
//     <Box sx={{ position: "relative", width: "100%" }}>
//       {/* Slider Container */}
//       <Box sx={{ position: "relative", width: "100%", height: "500px", overflow: "hidden" }}>
//         <Slider {...settings}>
//           {images.map((image, index) => (
//             <Box key={index}>
//               <img
//                 src={image}
//                 alt={`Slide ${index + 1}`}
//                 style={{
//                   width: "100%",
//                   height: "500px",
//                   objectFit: "cover",
//                 }}
//               />
//             </Box>
//           ))}
//         </Slider>

//         {/* Overlay Text */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "500px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "white",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             zIndex: 1,
//           }}
//         >
//           <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", textAlign: "center", px: 2 }}>
//             Your Space, Our Responsibility
//           </Typography>
//           <Typography variant="h6" component="p" sx={{ mt: 2, textAlign: "center", px: 2, maxWidth: "600px" }}>
//             Connect with trusted, professional cleaners to ensure your property always looks its best
//           </Typography>
//         </Box>
//       </Box>

//       {/* ========== MOVING WAVE AT BOTTOM ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           height: "80px",
//           overflow: "hidden",
//           backgroundColor: "white",
//         }}
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             width: "200%",
//             height: "100%",
//             animation: `${moveWave} 10s linear infinite`,
//           }}
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 1440 120"
//             preserveAspectRatio="none"
//             style={{
//               width: "50%",
//               height: "100%",
//               display: "inline-block",
//             }}
//           >
//             <path
//               fill={theme.palette.primary.main}
//               fillOpacity="0.1"
//               d="M0,64L48,69.3C96,75,192,85,288,90.7C384,96,480,96,576,85.3C672,75,768,53,864,48C960,43,1056,53,1152,64C1248,75,1344,85,1392,90.7L1440,96L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 1440 120"
//             preserveAspectRatio="none"
//             style={{
//               width: "50%",
//               height: "100%",
//               display: "inline-block",
//             }}
//           >
//             <path
//               fill="white"
//               fillOpacity="1"
//               d="M0,64L48,69.3C96,75,192,85,288,90.7C384,96,480,96,576,85.3C672,75,768,53,864,48C960,43,1056,53,1152,64C1248,75,1344,85,1392,90.7L1440,96L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
//             />
//           </svg>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default SliderComponent;



import React from "react";
import Slider from "react-slick";
import { Box, Typography, useTheme } from "@mui/material";
import { keyframes } from "@emotion/react";

const waveFlow = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-25%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const SliderComponent = () => {
  const theme = useTheme();
  
  const images = [
    require("../images/image1.jpg"),
    require("../images/image2.jpg"),
    require("../images/image3.jpg"),
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* Slider */}
      <Box sx={{ position: "relative", width: "100%", height: "500px" }}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <Box key={index}>
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%",
                  height: "500px",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Slider>

        {/* Overlay Text */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "500px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1,
          }}
        >
          <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", textAlign: "center", px: 2 }}>
            Your Space, Our Responsibility
          </Typography>
          <Typography variant="h6" component="p" sx={{ mt: 2, textAlign: "center", px: 2, maxWidth: "600px" }}>
            Connect with trusted, professional cleaners to ensure your property always looks its best
          </Typography>
        </Box>

        {/* ========== MOVING WAVE ON SLIDER BOTTOM - NO SHARP ANGLE ========== */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "80px",
            overflow: "hidden",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "200%",
              height: "100%",
              animation: `${waveFlow} 8s linear infinite`,
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 160"
              preserveAspectRatio="none"
              style={{
                width: "50%",
                height: "100%",
                display: "inline-block",
              }}
            >
              <path
                fill="white"
                fillOpacity="0.95"
                d="M0,96L48,101.3C96,107,192,117,288,117.3C384,117,480,107,576,96C672,85,768,75,864,80C960,85,1056,107,1152,112C1248,117,1344,107,1392,101.3L1440,96L1440,160L1392,160C1344,160,1248,160,1152,160C1056,160,960,160,864,160C768,160,672,160,576,160C480,160,384,160,288,160C192,160,96,160,48,160L0,160Z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 160"
              preserveAspectRatio="none"
              style={{
                width: "50%",
                height: "100%",
                display: "inline-block",
              }}
            >
              <path
                fill="white"
                fillOpacity="1"
                d="M0,96L48,101.3C96,107,192,117,288,117.3C384,117,480,107,576,96C672,85,768,75,864,80C960,85,1056,107,1152,112C1248,117,1344,107,1392,101.3L1440,96L1440,160L1392,160C1344,160,1248,160,1152,160C1056,160,960,160,864,160C768,160,672,160,576,160C480,160,384,160,288,160C192,160,96,160,48,160L0,160Z"
              />
            </svg>
          </Box>
        </Box>
      </Box>

      {/* White background continues */}
      <Box sx={{ backgroundColor: "white", width: "100%", pt: 2 }} />
    </Box>
  );
};

export default SliderComponent;






// import React from "react";
// import Slider from "react-slick";
// import { Box, Typography, useTheme } from "@mui/material";
// import { keyframes } from "@emotion/react";

// const waveFlow = keyframes`
//   0% {
//     transform: translateX(0);
//   }
//   50% {
//     transform: translateX(-25%);
//   }
//   100% {
//     transform: translateX(-50%);
//   }
// `;

// const SliderComponent = () => {
//   const theme = useTheme();
  
//   const images = [
//     require("../images/image1.jpg"),
//     require("../images/image2.jpg"),
//     require("../images/image3.jpg"),
//   ];

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 700,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//     fade: true,
//   };

//   return (
//     <Box sx={{ position: "relative", width: "100%" }}>
//       {/* Slider */}
//       <Box sx={{ position: "relative", width: "100%", height: "500px" }}>
//         <Slider {...settings}>
//           {images.map((image, index) => (
//             <Box key={index}>
//               <img
//                 src={image}
//                 alt={`Slide ${index + 1}`}
//                 style={{
//                   width: "100%",
//                   height: "500px",
//                   objectFit: "cover",
//                 }}
//               />
//             </Box>
//           ))}
//         </Slider>

//         {/* Overlay Text */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "500px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "white",
//             backgroundColor: "rgba(0, 0, 0, 0.4)",
//             zIndex: 1,
//           }}
//         >
//           <Typography variant="h3" component="h1" sx={{ fontWeight: "bold", textAlign: "center", px: 2 }}>
//             Your Space, Our Responsibility
//           </Typography>
//           <Typography variant="h6" component="p" sx={{ mt: 2, textAlign: "center", px: 2, maxWidth: "600px" }}>
//             Connect with trusted, professional cleaners to ensure your property always looks its best
//           </Typography>
//         </Box>

//         {/* ========== EXTRA TALL DRAMATIC WAVE ========== */}
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             width: "100%",
//             height: "150px", // Very tall wave
//             overflow: "hidden",
//             zIndex: 2,
//           }}
//         >
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               left: 0,
//               width: "200%",
//               height: "100%",
//               animation: `${waveFlow} 8s linear infinite`,
//             }}
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               viewBox="0 0 1440 250" // Larger viewBox
//               preserveAspectRatio="none"
//               style={{
//                 width: "50%",
//                 height: "100%",
//                 display: "inline-block",
//               }}
//             >
//               <path
//                 fill="white"
//                 fillOpacity="0.95"
//                 d="M0,160L48,168C96,176,192,192,288,192C384,192,480,176,576,160C672,144,768,128,864,136C960,144,1056,176,1152,184C1248,192,1344,176,1392,168L1440,160L1440,250L1392,250C1344,250,1248,250,1152,250C1056,250,960,250,864,250C768,250,672,250,576,250C480,250,384,250,288,250C192,250,96,250,48,250L0,250Z"
//               />
//             </svg>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               viewBox="0 0 1440 250"
//               preserveAspectRatio="none"
//               style={{
//                 width: "50%",
//                 height: "100%",
//                 display: "inline-block",
//               }}
//             >
//               <path
//                 fill="white"
//                 fillOpacity="1"
//                 d="M0,160L48,168C96,176,192,192,288,192C384,192,480,176,576,160C672,144,768,128,864,136C960,144,1056,176,1152,184C1248,192,1344,176,1392,168L1440,160L1440,250L1392,250C1344,250,1248,250,1152,250C1056,250,960,250,864,250C768,250,672,250,576,250C480,250,384,250,288,250C192,250,96,250,48,250L0,250Z"
//               />
//             </svg>
//           </Box>
//         </Box>
//       </Box>

//       {/* White background continues */}
//       <Box sx={{ backgroundColor: "white", width: "100%", pt: 4 }} />
//     </Box>
//   );
// };

// export default SliderComponent;